import React from 'react';
import YearMenu from './YearMenu';
import MakeMenu from './MakeMenu';
import ModelMenu from './ModelMenu';
import FakeMakeMenu from './FakeMakeMenu';
import FakeModelMenu from './FakeModelMenu';
import { Popover, PopoverBody, Button, Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import { ReCaptcha } from 'react-recaptcha-v3'


import service from '../dataService';

var initAuto = false;
var autocomplete;
var firstName;
var lastName;
var nexomReqID=0;

var componentForm = {
  street_number: 'short_name',
  route: 'long_name',
  locality: 'long_name',
  administrative_area_level_1: 'short_name',
  country: 'long_name',
  postal_code: 'short_name'
};

class UserFormAndCarMenu extends React.Component {
  leadPhoneVerified=false;
  testingUser = false;
  componentDidMount() {
    fetch("./cars.json")
      .then(response => response.json())
      .then(cars => this.setState({cars}))

  }

  constructor(props) {
    super(props);
   
    this.state = {
      cars: [],
      makeMenu: [],
      modelMenu: [],
  
      showFakeMake: {
        hidden: ''
      },
      showFakeModel: {
        hidden: ''
      },
      showMake: {
        hidden: 'hidden'
      },
      showModel: {
        hidden: 'hidden'
      },
      privacy_popup_open: false,
      verifyUserModal: false,
      modal: false,
      recaptchaToken: '',
      clientProfile: service.data.clientProfile
    };
    
  }

  privacy_toggle = this.privacy_toggle.bind(this);
  toggleModal = this.toggleModal.bind(this);
  toggleVerifyUserModal = this.toggleVerifyUserModal.bind(this);

  nameRef = React.createRef();
  phoneRef = React.createRef();
  emailRef = React.createRef();
  pinRef = React.createRef();
  addressRef = React.createRef();

  initAutoComplete = () => {
    var input = document.getElementById('autocomplete');
    if (initAuto === false) {
      autocomplete = new window.google.maps.places.Autocomplete(
      input,
      { types: ['address'], place_id: true }
      );

      // Avoid paying for data that you don't need by restricting the set of
      // place fields that are returned to just the address components.
      autocomplete.setFields(['address_component']);

      // When the user selects an address from the drop-down, populate the
      // address fields in the form.
      autocomplete.addListener('place_changed', this.fillInAddress);
      initAuto = true;
    }
  };

  fillInAddress=()=>{
    // Reset component Form
    componentForm["street_number"] = 'short_name';
    componentForm["route"]= 'long_name';
    componentForm["locality"]='long_name';
    componentForm["administrative_area_level_1"]= 'short_name';
    componentForm["country"]= 'long_name';
    componentForm["postal_code"]='short_name';

    // Get the place details from the autocomplete object.
    var place = autocomplete.getPlace();
    var makelloAddress = '';
    console.log("address ref: " + this.addressRef.current.value);

    // this.state.clientProfile.address = this.addressRef.current.value;
    // Get each component of the address from the place details,
    // and then fill-in the corresponding field on the form.
    for (var i = 0; i < place.address_components.length; i++) {
      var addressType = place.address_components[i].types[0];
      if (componentForm[addressType]) {
        var val = place.address_components[i][componentForm[addressType]];
        componentForm[addressType] = val;
        makelloAddress += val + ' ';
      }
      let client = this.state.clientProfile;
      client.address =makelloAddress;
      this.setState({ clientProfile: client });
    }
  };

  setYear = (e) => {
  let year = e.target.value;
  let client = this.state.clientProfile;
  // updating local clientProfile of dataService carYear, carMake and carModel. 
  client.carMake = "make";
  client.carModel = "model";
  this.setState({ clientProfile: client });

  this.makingMakeMenu(year);
  };

  setMake = (e) => {
  let make = e.target.value;
  let client = this.state.clientProfile;
    // updating local clientProfile of dataService carYear, carMake and carModel. 
    client.carMake = make;
    client.carModel = "model";
    this.setState({ clientProfile: client });
  this.makeModelMenu(make);
  };

  setModel = (e) => {
  let model = e.target.value;
  this.setState({model: model});
  };

  makingMakeMenu = (year) => {
    if (year !== "0") {
      this.showMake(true);
      this.setState({makeMenu: (this.state.cars[year])});
    } else {
      this.showMake(false);
      this.setState({makeMenu: []});
    }
    // disable model menus when we reset year and refresh make menu
    this.makeModelMenu("make");

  };

  showMake = (bool) => {
    if (bool) {
      this.setState({showFakeMake: {hidden: 'hidden'}});
      this.setState({showMake: {hidden: ''}});
    } else {
      this.setState({showFakeMake: {hidden: ''}});
      this.setState({showMake: {hidden: 'hidden'}});
      // disable model if disabling make
      this.showModel(false);
    }
  };

  makeModelMenu = (make) => {
    if (make !== "make") {
      this.showModel(true);
      this.setState({modelMenu: this.state.makeMenu[make]});
    } else {
      this.showModel(false);
      this.setState({modelMenu: []});
    }
  };

  showModel = (bool) => {
    if (bool) {
      this.setState({showFakeModel: {hidden: 'hidden'}});
      this.setState({showModel: {hidden: ''}});
    } else {
      this.setState({showFakeModel: {hidden: ''}});
      this.setState({showModel: {hidden: 'hidden'}});
    }
  };

  verifyCallback = (recaptchaToken) => {
    // Here you will get the final recaptchaToken!!!  
    console.log(recaptchaToken, "<= your recaptcha token")
        this.setState({ recaptchaToken: recaptchaToken });

  }

  submitHandler = (event) => {
    event.preventDefault();
    let fullName = this.state.clientProfile.fullName;
    let phone = this.state.clientProfile.phone;
    let email = this.state.clientProfile.email;
    let address = this.state.clientProfile.address;

    let splitName = fullName.split(' ');
    if(splitName.length <2){
      event.preventDefault();
      firstName = '';
      lastName = splitName[0];
    }
    else if( splitName.length >= 2 && fullName.length <= 120){
      firstName = splitName[0];
      // switch to functional programming with list tails
      lastName = splitName[1];

      var i;
      for (i = 2; i <= fullName.length; i++) {
        // update last name
        if(splitName[i] === undefined){
        continue;
        }
        else{
        lastName += " "+ splitName[i];
        }
      }
    }
    else{
      window.alert("Please enter your first and last name only(120 characters max).")
    }

    var [account, addressDomain] = email.split('@');
    var domainParts = addressDomain.split('.');
    if ((
      /^[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/.test(email) ||
      email === "" )&& email.length < 256 && account.length < 64 && domainParts.some(function (part) {
     return part.length < 63;
   })
    ) {
      event.preventDefault();
      // also check if work email for testing purposes
      if(/^(.)*@wipomo.com$/.test(email)) {
        this.testingUser = true;
      }

      if(/^(\+)?([0-9]{1})?[-. ]?(\()?([0-9]{3})(\))?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(phone)){
        var phoneNumber;
        console.log(" Matches phone number");
        // update phone number to accepted input for verification purposes
        var regex = /[+() .-]/g;
        phoneNumber = phone.replace(regex,'');
        if(phoneNumber.length === 10){
          phoneNumber= '1'+phoneNumber;
        }
        if(phoneNumber === '18587546183' || phoneNumber === '17608093391' || phoneNumber === '16193736244' || phoneNumber === '8587546183'){
          this.testingUser = true;
        }

        console.log("Cleaned up number is now: "+phoneNumber);
        var req_id = this.sendVerificationCheck(phoneNumber);

        console.log("Prinitng request id IN FIRST PART:" + req_id);
        this.toggleVerifyUserModal();
        event.preventDefault();
        console.log("does not go in here");
      }
      else if (phone === '' && !this.state.verifyUserModal){
      // Change Visible Page To Thank you page if user form is submitted,
      // with no additional info needed from customer.
        service.hideChanger('showThirdPart');

        this.sendToZoho(this.props.monthlyBill, firstName, lastName, this.state.clientProfile.email, "N/A", address, componentForm["postal_code"], this.state.clientProfile.mpg, this.state.clientProfile.dailyTrip, service.data.clientProfile.carYear, service.data.clientProfile.carMake, service.data.clientProfile.carModel);
      }
      else{
        event.preventDefault();
        window.alert("Please enter a valid number.");
      }
    }
    else{
      event.preventDefault();
      window.alert("Please enter a valid email address.");
    }
  }

  privacy_toggle(){
    this.setState({ privacy_popup_open: !this.state.privacy_popup_open });
  }

  toggleModal() {
    this.setState({
      modal: !this.state.modal
    });
  }

  toggleVerifyUserModal() {
    this.setState({
      verifyUserModal: !this.state.verifyUserModal
    });
  }


  async sendVerificationCheck(number){
    var url = "../api2/nexmo/request.php"
    console.log(url);
    let response =  await fetch(url, {
    method: "POST",
    body: JSON.stringify({
      number: number
    })
    })
    let resData = await response.json();
    nexomReqID = resData;
    console.log(resData);
    return resData;
  };

  verifyandUpdateView=()=>{
    console.log("Verify id is: "+ nexomReqID);
    var confirmed = this.confirmVerificationCode(this.state.clientProfile.pin, nexomReqID );
    console.log("returned confirmation of verification is: "+ confirmed);
  }

  async confirmVerificationCode(code, req_id){
    var url = "../api2/nexmo/verify2.php";
    let response = await fetch(url, {
    method: "POST",
    body: JSON.stringify({
      request_id: req_id,
      pin: code
    })
    })
    let resData = await response.json();
    console.log("returned verific. of resData is:"+ resData + " of type: "+ typeof(resData));

    if(resData === 0){
      console.log("PHP not sending object but successful verication");
      this.setConfirmationStatus();
    }
    else if(resData === 2){
      console.log("PHP not sending object but successful verication");
      window.alert("Your request is incomplete and missing a mandatory parameter. If unsure, refresh page and try again.")
    }
    else if(resData === 5){
      console.log("  Internal Error");
      window.alert("There was an Internal Error. Please Press Cancel and start over..");
    }
    else if(resData === 6){
      console.log("The code provided does not match the expected value");
      window.alert("The request could not be handled. Please Press Cancel and start over..");
    }
    else if(resData === 9){
      window.alert("Partner quota exceeded. Kindly Contact Makello to report this problem");
    }
    else if(resData === 10){
      console.log("Concurrent verifications to the same number are not allowed");
      window.alert("Concurrent verifications to the same number are not allowed");
    }
    else if(resData === 16){
      console.log("The code provided does not match the expected value");
      window.alert("The code provided does not match the expected value. After 3 tries, you will have to cancel and start over.");
    }
    else if(resData === 17){
      console.log("The wrong code was provided too many times");
      window.alert("The wrong code was provided too many times, Please click cancel and start over.");
    }
    else{
      console.log("Never comes in here! -TEST");
      console.log("Did not confirm verification code");
      // console.log(resData.error_text);
      window.alert(resData);
    }

    console.log("Lead phone verified: " + this.leadPhoneVerified);
    return this.leadPhoneVerified;
  } 

  setConfirmationStatus = () => {
    console.log("Sets phone verified variable to true");
    this.leadPhoneVerified = true;
    service.hideChanger('showThirdPart');
    this.sendToZoho(this.props.monthlyBill, firstName, lastName, this.state.clientProfile.email, this.state.clientProfile.phone, this.state.clientProfile.address, componentForm["postal_code"], this.state.clientProfile.mpg, this.state.clientProfile.dailyTrip, this.state.clientProfile.carYear, this.state.clientProfile.carMake, this.state.clientProfile.carModel);

    //this.props.showAllParts();
    this.toggleVerifyUserModal();
    console.log("Succes");
  };

  cancelVerificationAndCloseModal = () =>{
    // cancel verification request
    this.cancelVerificationRequest();

    //close modal
    this.toggleVerifyUserModal();
  }

  cancelVerificationRequest(){
    console.log("nexom request id: "+ nexomReqID);
    var url = "../api2/nexmo/cancel.php";
    fetch(url, {
      method: "POST",
      body: JSON.stringify({
        request_id: nexomReqID
      })
    })
      .then(resData => {
        console.log("Returning succesful response to cancel verification request");
        console.log(resData);        
      })
      .catch(function (e) {
      console.warn("Error: Caught a nexom verification cancellation error!");
      console.log(e);
      })
  }

  async sendToZoho(monthlyBill,firstName, lastName, email, phone, address, zip_code, mpg, miles, year, make, model){
    var fullName = firstName+' '+lastName;
    var monthly_loan_pmt = Number(service.data.clientProfile.selectedSystem.monthly_loan_payment)

    if(year === "0" ){
      year = 'N/A';
    }
    if(make === "make" ){
      make = 'N/A';
    }
    if(model === "model" ){
      model = 'N/A';
    }
    if(lastName === ''){
      fullName = "N/A"
    }
    if(address === ''){
      address = "N/A"
    }
    if(zip_code === 'short_name'){
      zip_code = '';
    }
    if(mpg === '0'){
      mpg = "N/A"
    }
    if(miles === '0'){
      miles = "N/A"
    }
         
    this.props.createCustomerEmail(fullName, phone, email, address, zip_code, miles, mpg, year, make, model, service.data.clientProfile.selectedSystem.system_to_display, this.testingUser);

    // update year again so that send to zoho is done last and await does not block emails from sending
    if(year === 'N/A' ){
      year = "0";
    }
    if(componentForm["street_number"] === 'short_name'){
      componentForm["street_number"] = 'N/A'
    }
    if(mpg === "N/A"){
      mpg = '0';
    }
    if(miles === "N/A"){
      miles = '0';
    }

    var cashorloanpayback =  Number(service.data.clientProfile.selectedSystem.payback);

     if(service.data.clientProfile.selectedSystem.cashorloan === "Loan"){
      cashorloanpayback = Number(service.data.clientProfile.selectedSystem.loan_payback).toLocaleString(navigator.language, { minimumFractionDigits: 1 });
    }
    var url = "../api2/zoho.php?energyAnalysis";
    let response =  await fetch(url, {
      method: "POST",
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: JSON.stringify({
        First_Name: firstName,
        Last_Name: lastName,
        Email: email,
        Phone: phone,
        route: componentForm["route"],
        street_number: componentForm["street_number"],
        locality: componentForm["locality"],
        administrative_area_level_1: componentForm["administrative_area_level_1"],
        postal_code: componentForm["postal_code"],
        lead_selected_system: service.data.clientProfile.selectedSystem.system_type,
        lead_payment_type: this.props.payment_type,
        optimal_system: service.data.chartData.Optimal.system_type,
        optimal_payment_type: service.data.chartData.Optimal.cashorloan,
        lead_savings: service.data.clientProfile.selectedSystem.savingsAmount,
        lead_installFee: service.data.clientProfile.selectedSystem.installFee,
        lead_monthly_pmt: monthly_loan_pmt,
        lead_source: this.props.campaign.name,
        Monthly_Electric_Bill: monthlyBill,
        lead_payback: cashorloanpayback,
        Vehicle_MPG: mpg,
        Daily_Vehicle_Miles: miles,
        Vehicle_Year: year ,
        Vehicle_Make: make,
        Vehicle_Model: model,
        source_page: this.props.campaign.MakelloPage,
        referer: service.data.myReferer,
        recaptchaToken: this.state.recaptchaToken
      })
    })

    let resData = await response.json();
    console.log(resData);
  
  }

  onChangeHandler(e, more) {
    let client = this.state.clientProfile;
    // updating local clientProfile of dataService carYear, carMake and carModel. 
    client[e.currentTarget.name] = e.currentTarget.value;
    this.setState({ clientProfile: client });
    // sets this states year make and model menus locally within component
    if(more === 'yearMenu') {
      this.setYear(e);
    }
    if(more === 'makeMenu') {
      this.setMake(e);
    }
    if(more === 'modelMenu') {
      this.setModel(e);
    }
  }

  render() {

  return(<div className="saveMoneyBox">
  <div className="row">
    <div className="col-md-8 offset-md-2">
      <h4 className='text-white text-center mb-3'>Are you ready to save money?</h4>
      <div className="card border-0 rounded-0">
        <div className="card-body">
          <div className="text-center mb-4">
            <p className='light deactive-color m2lBottom-title'>Get a custom energy savings report from Makello</p>
          </div>
          <div className="row">
          <div className="col-md-10 offset-md-1 col-lg-8 offset-lg-2">
            <div className="form-group">
                <input type="name" className="form-control userInput light full-width" placeholder='Full Name' onChange={(e) => this.onChangeHandler(e)} value={this.state.clientProfile.fullName} name="fullName" />
              </div>
              <div className="form-group">
                <input value={this.state.clientProfile.email} onChange={(e) => this.onChangeHandler(e)} type="email" className="form-control userInput light full-width" placeholder='Email*' name="email" onInvalid={() => { alert('Please enter a valid email address.') }} required />
              </div>
              <div className="form-group">
                <input type="text" value={this.state.clientProfile.phone} name="phone" onChange={(e) => this.onChangeHandler(e)} className="form-control userInput light full-width" placeholder='Phone' />
              </div>
            <div>
            <Modal isOpen={this.state.verifyUserModal} toggle={this.toggleVerifyUserModal} centered={true}>
              <ModalHeader toggle={this.toggle}>Check your phone for a text message verification code</ModalHeader>
              <ModalBody>
                <input type="number" onChange={(e) => this.onChangeHandler(e)} name="pin" value={this.state.clientProfile.pin} className="form-control userInput light" id="pin" aria-describedby="pin" placeholder="Enter the code here.. " />
              </ModalBody>
              <ModalFooter>
                <Button color="primary" onClick={() => { this.verifyandUpdateView() }}>Verify</Button>
                <Button color="secondary" onClick={() => { this.cancelVerificationAndCloseModal() }}>Cancel</Button>
              </ModalFooter>
            </Modal>
          </div>
          <div className="form-group">
            <input id='autocomplete' onFocus={this.initAutoComplete} name="address" onChange={(e) => this.onChangeHandler(e)} type="text" className="form-control userInput light full-width" placeholder='Enter full address' ref={this.addressRef} />
          </div>
          <div className='card bg-light mt-5 rounded-1'>
          <div className="card-body">
              <div className='styled-select'>
              <h5 className="text-center">Interested to see how much a plug-in vehicle can increase savings?</h5>
                <div className="form-group mt-4">
                <div className="form-group">
                  <label>What is your daily average commute in miles?</label>
                  <input type="number" className="form-control" id="inputDailyTrip" name="dailyTrip" value={this.state.clientProfile.dailyTrip} onChange={(e) => this.onChangeHandler(e)} min="0"/>
                </div>
                <div className="form-group">
                  <label>What is your average MPG / MPGe?</label>
                  <input type="number" className="form-control" id="inputMPG" name="mpg" value={this.state.clientProfile.mpg} onChange={(e) => this.onChangeHandler(e)}   min="0"/>
                </div>
                <div className="form-group">Plug-In Vehicle
                  <div className="carMenu">
                    <YearMenu year={this.state.clientProfile.carYear} name="carYear" setYear={(e) => this.onChangeHandler(e, 'yearMenu')} />
                  </div>
                <div className={`${this.state.showFakeMake.hidden} carMenu`}>
                  <FakeMakeMenu />
                </div>
                <div className={`${this.state.showMake.hidden} carMenu`}>
                  <MakeMenu make={this.state.clientProfile.carMake} name="carMake" setMake={(e) => this.onChangeHandler(e, 'makeMenu')}
                            makeMenu={this.state.makeMenu} />
                </div>
                <div className={`${this.state.showFakeModel.hidden} carMenu`}>
                  <FakeModelMenu className={this.state.showFakeModel} />
                </div>
                <div className={`${this.state.showModel.hidden} carMenu`}>
                  <ModelMenu model={this.state.clientProfile.carModel} name="carModel" setModel={(e) => this.onChangeHandler(e, 'modelMenu')} modelMenu={this.state.modelMenu} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <ReCaptcha
            sitekey="6LdivmwrAAAAANTq_pjjLG2WMlU775lMtnzCGjnz"
            action='contact'
            verifyCallback={this.verifyCallback}
          />
        <br></br>
        <div className="form-group">
          <input className='btn btn-primary submitButton light' value="Submit" type='submit' onClick={this.submitHandler} />
        </div>
        <p text-align="center">
          Now serving San Diego<br></br>
          We will not share your data.
          <span className="readme" id="privacy_icon" onMouseOver={this.privacy_toggle} onMouseOut={this.privacy_toggle}>&nbsp; 
            <img src="./images/info_icon.png" alt="info" style={{ width: '13px', height: '13px' }} />
          </span>
        </p>
      </div>
    </div>
  </div>
</div>
</div>
</div>
<Popover placement="auto" isOpen={this.state.privacy_popup_open} target="privacy_icon" toggle={this.privacy_toggle} >
  <PopoverBody>
    <div className="payback-disclaimer">
    Review privacy policy link on footer of this page
    </div>
  </PopoverBody>
</Popover>
</div>
</div>)
}
}

export default UserFormAndCarMenu;